import { create } from 'zustand';

/**
 * Sinal global para abrir o form de agendamento de comitê da `CommitteesSection`. O menu "Ações do
 * Deal" (DealDrawer) chama `requestSchedule()`, que incrementa `requestTick`; a seção observa o tick
 * e, a cada incremento, abre o agendamento e rola até a seção. Tick (e não boolean) para que cliques
 * repetidos sempre disparem, mesmo com o form já aberto. Mesmo estilo do `dealDrawerStore`.
 */
interface CommitteeScheduleState {
  requestTick: number;
  requestSchedule: () => void;
}

export const useCommitteeSchedule = create<CommitteeScheduleState>()((set) => ({
  requestTick: 0,
  requestSchedule: () => set((s) => ({ requestTick: s.requestTick + 1 })),
}));
